// extracted by mini-css-extract-plugin
module.exports = {"container":"Cf","detailRateButton":"Ch","fadeIn":"Ci","fadeOut":"Cj","userRatingIcon":"Ck","detailRateButtonLabel":"Cl","isRental":"Cm"};